import { render, staticRenderFns } from "./SitesWithoutLandlords.vue?vue&type=template&id=8670c3c4"
import script from "./SitesWithoutLandlords.vue?vue&type=script&lang=js"
export * from "./SitesWithoutLandlords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports